import { get } from '@/base/http-base.js'
/**
 *
 *查询推荐产品
 * @export
 * params{amount}
 * https://cf.jd.com/pages/viewpage.action?pageId=989960010
 */
export function describeOperations(data) {
  return get('v1/user/describeOperations', data)
}
